import React from 'react'
import { CgCopy, CgTrash } from 'react-icons/cg'

import { useListenWorkoutExercisesQuery, useSavePartExercisesMutation } from 'modules/Programs/programApi'
import { useListenEnableDefaultProgressionTagQuery } from 'modules/ContentTags/contentTagsApi'

import { insertOneToArray } from 'common/utils/arrayUtils'
import { createUID } from 'common/utils/createUID'
import { Tooltip } from 'common/components/Tooltip/Tooltip'
import { getNewExercise } from 'modules/Programs/programModels'
import { DefaultProgressionTagPopover } from './DefaultProgressionTagPopover'

export function ExerciseActions(props) {
  const {
    exercise,
    workoutId,
    programId,
    partIdx,
    exIdx,
    orgId,
    actions = ['duplicate', 'delete'],
    isProgressionTagPopoverOpen,
    setIsProgressionTagPopoverOpen,
  } = props

  const { data: exercises } = useListenWorkoutExercisesQuery({ orgId, workoutId, partIdx })
  const [savePartExercises] = useSavePartExercisesMutation()
  const { data: enableDefaultProgressionTag } = useListenEnableDefaultProgressionTagQuery({ coachOrgId: orgId })
  return (
    <>
      {enableDefaultProgressionTag === true && Boolean(exercise?.id) && exercise?.type !== 'benchmark' && (
        <DefaultProgressionTagPopover
          exercise={exercise}
          orgId={orgId}
          workoutId={workoutId}
          programId={programId}
          partIdx={partIdx}
          exIdx={exIdx}
          isOpen={isProgressionTagPopoverOpen}
          setIsOpen={setIsProgressionTagPopoverOpen}
        />
      )}
      {actions.map((action) => {
        if (action === 'duplicate') {
          return (
            <Tooltip key={action} content='Duplicate' triggerClasses='flex'>
              <button
                aria-label='Duplicate exercise'
                className='flex'
                onClick={(e) =>
                  handleDuplicateExercise({
                    e,
                    exercises,
                    exerciseToDuplicate: exercise,
                    workoutId,
                    partIdx,
                    savePartExercises,
                    orgId,
                  })
                }
              >
                <CgCopy
                  data-testid='copyPartIcon'
                  className='cursor-pointer ml-[2px] w-4 h-4 text-gray-500 hover:text-tGreen'
                />
              </button>
            </Tooltip>
          )
        }

        if (action === 'delete') {
          return (
            <Tooltip key={action} content='Delete' triggerClasses='flex'>
              <button
                aria-label='Delete exercise'
                className='flex'
                onClick={(e) => {
                  handleDeleteExercise({
                    e,
                    exercises,
                    exerciseToDelete: exercise,
                    workoutId,
                    partIdx,
                    savePartExercises,
                    orgId,
                  })
                }}
              >
                <CgTrash
                  className={`cursor-pointer w-[18px] h-[18px] text-gray-500 hover:text-tRed ${
                    actions?.length === 1 ? '' : 'ml-1.5'
                  }`}
                />
              </button>
            </Tooltip>
          )
        }

        return null
      })}
    </>
  )
}

const handleDuplicateExercise = async ({
  e,
  exercises,
  exerciseToDuplicate,
  workoutId,
  partIdx,
  savePartExercises,
  orgId,
}) => {
  e.stopPropagation()

  const exerciseIndex = exercises.findIndex((exercise) => exercise.dndUID === exerciseToDuplicate.dndUID)
  const exerciseToInsert = exercises[exerciseIndex]
  const exerciseWithUID = { ...exerciseToInsert, dndUID: createUID() }

  const updatedExercises = insertOneToArray(exercises, exerciseIndex + 1, exerciseWithUID)

  await savePartExercises({
    orgId,
    workoutId,
    partIndex: partIdx,
    exercises: updatedExercises,
  })
}

const handleDeleteExercise = async ({
  e,
  exercises,
  workoutId,
  partIdx,
  exerciseToDelete,
  savePartExercises,
  orgId,
}) => {
  e.stopPropagation()
  if (exercises?.length > 1) {
    const updatedExercises = exercises.filter((exercise) => exercise.dndUID !== exerciseToDelete.dndUID)

    await savePartExercises({
      orgId,
      workoutId,
      partIndex: partIdx,
      exercises: updatedExercises,
    })
  } else {
    // When deleting last exercise in a part,
    // replace it with a new empty exercise
    const newExercise = getNewExercise()
    await savePartExercises({
      orgId,
      workoutId,
      partIndex: partIdx,
      exercises: [newExercise],
    })
  }
}
